import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useSageCustomers = () => {
  const [sageCustomers, setSageCustomers] = useState([]);
  const [rawCustomers, setRawCustomers] = useState([]);

  useEffect(() => {
    const fetchSageCustomers = async () => {
      try {
        const res = await customAxios.get('/CRM/GetSageCustomers', {
          headers: authHeader(),
        });

        if (res.status === 200 && Array.isArray(res.data)) {
          setRawCustomers(res.data);
          const custNames = res.data.map(item => item.customerName);
          setSageCustomers(custNames);
        } else {
          setSageCustomers([]);
          setRawCustomers([]);
        }
      } catch (err) {
        console.error('Failed to fetch Sage customers:', err);
        setSageCustomers([]);
        setRawCustomers([]);
      }
    };

    fetchSageCustomers();
  }, []);

  const getCustomerCode = customerName => rawCustomers.find(item => item.customerName === customerName)?.customerCode ?? '';

  return { sageCustomers, getCustomerCode };
};

export default useSageCustomers;
